import React from 'react';
import { FormattedMessage } from 'react-intl';

export enum Locale {
    ENGLISH = 'en-US',
    DUTCH = 'nl-BE',
    FRENCH = 'fr-FR',
    GERMAN = 'de-DE'
}

export const Languages: { value: Locale; displayName: string; shortDisplayName: string }[] = [
    {
        value: Locale.ENGLISH,
        displayName: 'English',
        shortDisplayName: 'EN'
    },
    {
        value: Locale.DUTCH,
        displayName: 'Nederlands',
        shortDisplayName: 'NL'
    },
    {
        value: Locale.FRENCH,
        displayName: 'Français',
        shortDisplayName: 'FR'
    },
    {
        value: Locale.GERMAN,
        displayName: 'Deutsch',
        shortDisplayName: 'DE'
    }
];

export const convertLanguage = (lang: Locale | '') => {
    switch (lang) {
        case Locale.DUTCH:
            return Dutch;
        case Locale.ENGLISH:
            return English;
        case Locale.FRENCH:
            return French;
        case Locale.GERMAN:
            return German;
        default:
            return '';
    }
};

export const convertAbbreviation = (abbr: string | '') => {
    switch (abbr) {
        case 'en_us':
            return Locale.ENGLISH;
        case 'nl_be':
            return Locale.DUTCH;
        case 'fr_fr':
            return Locale.FRENCH;
        case 'de_de':
            return Locale.GERMAN;
        default:
            return Locale.ENGLISH;
    }
};

const Dutch = (
    <FormattedMessage
        id='LanguageConverter.Dutch'
        description={'Converts nl_BE to Dutch in its corresponding language'}
        defaultMessage='Nederlands'
    />
);

const English = (
    <FormattedMessage
        id='LanguageConverter.English'
        description={'Converts en_GB to English in its corresponding language'}
        defaultMessage='English'
    />
);

const French = (
    <FormattedMessage
        id='LanguageConverter.French'
        description={'Converts fr_BE to French in its corresponding language'}
        defaultMessage='Français'
    />
);

const German = (
    <FormattedMessage
        id='LanguageConverter.German'
        description={'Converts de-DE to German in its corresponding language'}
        defaultMessage='Deutsch'
    />
);
